import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'DictCodeSelect',
  props: {
  options: {
    type: Array,
    default: () => []
  },
  multiple: {
    type: Boolean,
    default: false
  },
  placeholder: {
    type: String,
    default: '请选择'
  }
},
  setup(__props) {

const currentValue = ref('')

// eslint-disable-next-line no-undef


return (_ctx: any,_cache: any) => {
  const _component_el_select_v2 = _resolveComponent("el-select-v2")!

  return (_openBlock(), _createBlock(_component_el_select_v2, {
    modelValue: currentValue.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((currentValue).value = $event)),
    "max-collapse-tags": 3,
    multiple: __props.multiple,
    options: __props.options,
    placeholder: __props.placeholder,
    clearable: "",
    "collapse-tags": "",
    "collapse-tags-tooltip": "",
    filterable: "",
    class: "dict-code-select"
  }, null, 8, ["modelValue", "multiple", "options", "placeholder"]))
}
}

})